import React, { Component } from "react";
import * as _ from "lodash";
import ReactTooltip from "react-tooltip";
import axios from "axios";
import compareValues from "./SortValue.js";

function CustomComp(props) {
  return (
    <div>
      <span className="toolTipHeader">Employees in this Cost Center :</span>
      <ul className="accorCol accorcol1">
        {props.dataTip != null &&
          props.dataTip
            .slice(0, Math.ceil(props.dataTip.length / 2))
            .map((it) => {
              return <li>{it}</li>;
            })}
      </ul>
      <ul className="accorCol accorcol2">
        {props.dataTip != null &&
          props.dataTip.slice(Math.ceil(props.dataTip.length / 2)).map((it) => {
            return <li>{it}</li>;
          })}
      </ul>
    </div>
  );
}

class CostCenterPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      PayrollCCItemData: [],
      sessionId: "",
      payrollCCcode: "",
      payrollCCname: "",
      leveldown: false,
      isMandatory: false,
      selectedvalue: "",
      isLoaded: false,
      isDisplaylevelupdown: false,
      selectedlevel: "",
      openItem: 0,
    };
  }
  async componentDidMount() {
    window.addEventListener("resize", this.SetWidth);
    if (this.props.payrollCCCode != "") {
      this.setState({
        payrollCCcode: this.props.payrollCCCode,
        payrollCCname: this.props.payrollCCName,
        selectedvalue: this.props.payrollCCCode,
        selectedlevel: this.props.selectedlevelCC,
      });
    }
    if (this.props.mngwwid != "" && this.props.locationreferenceID != "") {
      await axios({
        method: "POST",
        url: process.env.REACT_APP_WORKDAY_API_URL + "getPayrollCC",
        headers: {
          apiKey: process.env.REACT_APP_WORKDAY_API_KEY,
          clientKey: process.env.REACT_APP_WORKDAY_API_CLIENTKEY,
          "Content-Type": "application/json",
        },
        data: {
          sessionId: this.props.sessionID,
          managerWWID: this.props.mngwwid,
          locationCode: this.props.locationreferenceID,
          leCode: this.props.lecode,
          payrollMRCCode: this.props.mrccode,
        },
      })
        .then((res) => {
          this.setState({
            PayrollCCItemData: res.data.payrollCostCenterList,
            isLoaded: true,
          });
        })
        .catch((error) => {
          //on error
          // alert("There is an error in API call mngid.");
        });
    } else {
    }

    if (this.state.PayrollCCItemData.length > 0) {
      const checkleveldownarr = this.state.PayrollCCItemData.map((item) => {
        return item.level;
      })
        .filter((val, id, array) => array.indexOf(val) == id)
        .filter(function (el) {
          return el != null && el != "";
        })
        .sort((a, b) => a - b);

      let checkthirdvalue = checkleveldownarr[2];

      if (checkthirdvalue != undefined) {
        if (checkthirdvalue == this.props.selectedlevelCC) {
          this.setState({ leveldown: true });
        } else {
          this.setState({ leveldown: false });
        }
        this.setState({ isDisplaylevelupdown: true });
      } else {
        this.setState({ isDisplaylevelupdown: false });
      }
    }
    // console.log("Selected Level:-",this.props.selectedlevelCC)
    this.SetWidth();
  }
  SetWidth = () => {
    var header = document.querySelectorAll(".accordionheader");
    for (var i = 0; i < header.length; i++) {
      header[i].nextSibling.style.width =
        this.DimensionWidth(header[i].parentElement) -
        this.DimensionWidth(header[i].previousSibling) -
        this.DimensionWidth(header[i]) -
        20 +
        "px";
    }
  };
  DimensionWidth = (elmID) => {
    var elmHeight,
      elmMargin,
      elm = elmID;
    if (document.all) {
      // IE
      elmHeight = elm.offsetWidth;
      elmMargin =
        parseInt(elm.currentStyle.marginLeft, 10) +
        parseInt(elm.currentStyle.marginRight, 10);
    } else {
      // Mozilla
      elmHeight = elm.offsetWidth;
      elmMargin =
        parseInt(
          document.defaultView
            .getComputedStyle(elm, "")
            .getPropertyValue("margin-left")
        ) +
        parseInt(
          document.defaultView
            .getComputedStyle(elm, "")
            .getPropertyValue("margin-right")
        );
    }
    return elmHeight + elmMargin;
  };
  payrollcostcenter = (payrollcostcenteritemdata) => {
    if (payrollcostcenteritemdata.length > 0) {
      let payrollcostcenteritemdataSort = payrollcostcenteritemdata.sort(
        compareValues("payrollCostCenterCode")
      );
      // console.log(payrollcostcenteritemdataSort);
      const leveluparr = payrollcostcenteritemdataSort
        .map((item) => {
          return item.level;
        })
        .filter((val, id, array) => array.indexOf(val) == id)
        .filter(function (el) {
          return el != null && el != "";
        })
        .sort((a, b) => a - b);
      let secondvalue = leveluparr[1];

      if (secondvalue != undefined) {
        return this.getMergedEmployees(
          payrollcostcenteritemdataSort.filter((it) => {
            return it.level <= secondvalue;
          })
        ).map((item) => (
          <li
            key={item.payrollCostCenterCode}
            value={item.payrollCostCenterCode}
            className={
              this.state.selectedvalue == item.payrollCostCenterCode &&
              this.state.selectedlevel == item.level
                ? "lilist select-search-box__row lelist changebgcolor"
                : "lilist select-search-box__row lelist"
            }
            onClick={(e) => {
              this.handleCheck(
                item.payrollCostCenterCode,
                item.payrollCostCenterName,
                item.level
              );
            }}
          >
            <div className="accordionrowheader">
              <span className="leradiospan">
                <input
                  type="radio"
                  name="radio"
                  id={item.payrollCostCenterCode}
                  checked={
                    this.state.payrollCCcode === item.payrollCostCenterCode &&
                    this.state.selectedlevel == item.level
                  }
                  value={item.payrollCostCenterName}
                  onChange={(e) => {
                    this.handleCheck(
                      item.payrollCostCenterCode,
                      item.payrollCostCenterName,
                      item.level
                    );
                  }}
                ></input>
              </span>
              <span
                className="accordionheader"
                title={item.payrollCostCenterName}
              >
                {item.payrollCostCenterCode} - {item.payrollCostCenterName}
              </span>
              <span
                className="hoverlelist"
                style={{ float: "right" }}
                onClick={(e) => {
                  this.setState({
                    openItem:
                      this.state.openItem === item.payrollCostCenterCode
                        ? 0
                        : item.payrollCostCenterCode,
                  });
                  e.stopPropagation();
                }}
              >
                {this.sortemployee(item.employees)}{" "}
                <span>
                  {" "}
                  <i
                    className={
                      this.state.openItem === item.payrollCostCenterCode
                        ? "up"
                        : "down"
                    }
                  ></i>
                </span>
              </span>
            </div>
            <div className="accordionrowcontet">
              {this.state.openItem === item.payrollCostCenterCode ? (
                <CustomComp
                  dataTip={item.employees.map((it) => {
                    return it.name;
                  })}
                />
              ) : (
                ""
              )}
            </div>
          </li>
        ));
      } else {
        return payrollcostcenteritemdataSort.map((item) => (
          <li
            key={item.payrollCostCenterCode}
            value={item.payrollCostCenterCode}
            className={
              this.state.selectedvalue == item.payrollCostCenterCode &&
              this.state.selectedlevel == item.level
                ? "lilist select-search-box__row lelist changebgcolor"
                : "lilist select-search-box__row lelist"
            }
            onClick={(e) => {
              this.handleCheck(
                item.payrollCostCenterCode,
                item.payrollCostCenterName,
                item.level
              );
            }}
          >
            <div className="accordionrowheader">
              <span className="leradiospan">
                <input
                  type="radio"
                  name="radio"
                  id={item.payrollCostCenterCode}
                  checked={
                    this.state.payrollCCcode === item.payrollCostCenterCode &&
                    this.state.selectedlevel == item.level
                  }
                  value={item.payrollCostCenterName}
                  onChange={(e) => {
                    this.handleCheck(
                      item.payrollCostCenterCode,
                      item.payrollCostCenterName,
                      item.level
                    );
                  }}
                ></input>
              </span>
              <span
                className="accordionheader"
                title={item.payrollCostCenterName}
              >
                {item.payrollCostCenterCode} - {item.payrollCostCenterName}
              </span>
              <span
                className="hoverlelist"
                style={{ float: "right" }}
                onClick={(e) => {
                  this.setState({
                    openItem:
                      this.state.openItem === item.payrollCostCenterCode
                        ? 0
                        : item.payrollCostCenterCode,
                  });
                  e.stopPropagation();
                }}
              >
                {this.sortemployee(item.employees)}{" "}
                <span>
                  {" "}
                  <i
                    className={
                      this.state.openItem === item.payrollCostCenterCode
                        ? "up"
                        : "down"
                    }
                  ></i>
                </span>
              </span>
            </div>
            <div className="accordionrowcontet">
              {this.state.openItem === item.payrollCostCenterCode ? (
                <CustomComp
                  dataTip={item.employees.map((it) => {
                    return it.name;
                  })}
                />
              ) : (
                ""
              )}
            </div>
          </li>
        ));
      }
    }
  };
  payrollcostcenterleveldown = (payrollcostcenteritemdata) => {
    this.SetWidth();
    if (payrollcostcenteritemdata.length > 0) {
      let payrollcostcenteritemdatadownSort = payrollcostcenteritemdata.sort(
        compareValues("payrollCostCenterCode")
      );
      const leveldownarr = payrollcostcenteritemdatadownSort
        .map((item) => {
          return item.level;
        })
        .filter((val, id, array) => array.indexOf(val) == id)
        .filter(function (el) {
          return el != null && el != "";
        })
        .sort((a, b) => a - b);

      let thirdvalue = leveldownarr[2];

      if (thirdvalue != undefined) {
        // this.maplevel(thirdvalue);
        return this.getMergedEmployees(
          payrollcostcenteritemdatadownSort.filter((it) => {
            return it.level == thirdvalue;
          })
        ).map((item) => (
          <li
            key={item.payrollCostCenterCode}
            value={item.payrollCostCenterCode}
            className={
              this.state.selectedvalue == item.payrollCostCenterCode &&
              this.state.selectedlevel == item.level
                ? "lilist select-search-box__row lelist changebgcolor"
                : "lilist select-search-box__row lelist"
            }
            onClick={(e) => {
              this.handleCheck(
                item.payrollCostCenterCode,
                item.payrollCostCenterName,
                item.level
              );
            }}
          >
            <div className="accordionrowheader">
              <span className="leradiospan">
                <input
                  type="radio"
                  name="radio"
                  id={item.payrollCostCenterCode}
                  checked={
                    this.state.payrollCCcode === item.payrollCostCenterCode &&
                    this.state.selectedlevel == item.level
                  }
                  value={item.payrollCostCenterName}
                  onChange={(e) => {
                    this.handleCheck(
                      item.payrollCostCenterCode,
                      item.payrollCostCenterName,
                      item.level
                    );
                  }}
                ></input>
              </span>
              <span
                className="accordionheader"
                title={item.payrollCostCenterName}
              >
                {item.payrollCostCenterCode} - {item.payrollCostCenterName}
              </span>
              <span
                className="hoverlelist"
                style={{ float: "right" }}
                onClick={(e) => {
                  this.setState({
                    openItem:
                      this.state.openItem === item.payrollCostCenterCode
                        ? 0
                        : item.payrollCostCenterCode,
                  });
                  e.stopPropagation();
                }}
              >
                {this.sortemployee(item.employees)}{" "}
                <span>
                  {" "}
                  <i
                    className={
                      this.state.openItem === item.payrollCostCenterCode
                        ? "up"
                        : "down"
                    }
                  ></i>
                </span>
              </span>
            </div>
            <div className="accordionrowcontet">
              {this.state.openItem === item.payrollCostCenterCode ? (
                <CustomComp
                  dataTip={item.employees.map((it) => {
                    return it.name;
                  })}
                />
              ) : (
                ""
              )}
            </div>
          </li>
        ));
      }
    }
  };
  getMergedEmployees = (inputArray) => {
    const groupedJson = inputArray.reduce((rv, x) => {
      (rv[x["payrollCostCenterCode"]] =
        rv[x["payrollCostCenterCode"]] || []).push(x);
      return rv;
    }, {});
    const groupedArray = Object.keys(groupedJson).map(
      (key) => groupedJson[key]
    );
    const toMerge = groupedArray.filter((d) => d.length > 1);
    const toRetain = groupedArray.filter((d) => d.length == 1);
    let finalArray = [];
    toMerge.map((arr) => {
      let newData = {
        payrollCostCenterCode: arr[0].payrollCostCenterCode,
        payrollCostCenterName: arr[0].payrollCostCenterName,
        level: arr[0].level,
        employees: [],
      };
      let emplArray = [];
      arr.map((d) => {
        emplArray = emplArray.concat(d.employees);
      });

      let uniqeEmployee = [];
      emplArray.filter(function (item) {
        var i = uniqeEmployee.findIndex((x) => x.name == item.name);
        if (i <= -1) {
          uniqeEmployee.push({ name: item.name });
        }
        return null;
      });
      newData.employees = uniqeEmployee;
      finalArray.push(newData);
    });
    toRetain.map((data) => {
      finalArray.push(data[0]);
    });
    finalArray = finalArray.sort(compareValues("payrollCostCenterCode"));
    return finalArray;
  };
  sortemployee = (employee) => {
    const sortedemployee = employee.sort((a, b) =>
      a.name.localeCompare(b.name)
    );
    return sortedemployee.length === 0
      ? ""
      : sortedemployee.length === 1
        ? sortedemployee[0].name
        : sortedemployee.length === 2
          ? sortedemployee[0].name + " & " + sortedemployee[1].name
          : sortedemployee.length === 3
            ? sortedemployee[0].name +
              " , " +
              sortedemployee[1].name +
              " & " +
              "1 other"
            : sortedemployee.length > 3
              ? sortedemployee[0].name +
                " , " +
                sortedemployee[1].name +
                " & " +
                (sortedemployee.length - 2) +
                "  others"
              : "";
  };
  handleCheck = (id, val, level) => {
    this.setState({
      payrollCCcode: id,
      payrollCCname: val,
      selectedvalue: id,
      selectedlevel: level,
      openItem: 0,
    });
  };

  handlePayrollCCData = () => {
    if (this.state.payrollCCcode != "") {
      this.props.onclickPayrollCCNext(
        this.state.payrollCCcode,
        this.state.payrollCCname,
        this.state.selectedlevel
      );
      this.setState({ isMandatory: false });
    } else {
      this.setState({ isMandatory: true });
    }
  };
  handlePayrollCCDataBack = () => {
    this.props.onclickpayrollCCBack();
  };
  showleveldown = () => {
    this.setState({ leveldown: !this.state.leveldown });
  };
  render() {
    return (
      <div>
        {this.state.isLoaded ? (
          <div className="accordionlist">
            <h4 className="listheader">
              Please select a recommended{" "}
              <span className="listheadertext">Payroll Cost Center (CC):</span>
            </h4>
            <ul className="ulist">
              {this.state.leveldown === false
                ? this.payrollcostcenter(this.state.PayrollCCItemData)
                : ""}
              {this.state.leveldown === true
                ? this.payrollcostcenterleveldown(this.state.PayrollCCItemData)
                : ""}
              {this.state.isDisplaylevelupdown === true ? (
                <li
                  className="showlevelupdowntoggle"
                  onClick={this.showleveldown}
                >
                  <span>
                    {" "}
                    {this.state.leveldown === true
                      ? "Show me one level up"
                      : "Show me one level down"}
                  </span>
                </li>
              ) : (
                ""
              )}
              <li
                className={
                  this.state.selectedvalue == "noa"
                    ? "lenoneoftheabove changebgcolor"
                    : "lenoneoftheabove"
                }
                onClick={(e) => {
                  this.handleCheck("noa", "noa", "noa");
                }}
              >
                <span className="leradiospan">
                  <input
                    type="radio"
                    id="noa"
                    name="radio"
                    value="noa"
                    checked={this.state.payrollCCcode === "noa"}
                    onChange={(e) => {
                      this.handleCheck("noa", "noa", "noa");
                    }}
                  ></input>
                </span>
                <span title="None of the above">None of the above</span>
              </li>
            </ul>
          </div>
        ) : (
          <div className="dataLoader">Loading data please wait...</div>
        )}
        {this.state.isMandatory === true ? (
          <label className="MandatoryFields">
            Please select a recommended Payroll Cost Center (CC)
          </label>
        ) : (
          ""
        )}
        {this.state.isLoaded ? (
          <div className="last-column rowhead lebtn">
            <div className="nextbtn leback">
              {" "}
              <input
                type="submit"
                value="< Back"
                className="btncls"
                onClick={this.handlePayrollCCDataBack}
              />
            </div>
            <div className="nextbtn lenext">
              {" "}
              <input
                type="submit"
                value="Next >"
                onClick={this.handlePayrollCCData}
                className="btncls"
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default CostCenterPage;
